import ProfileIcon from "./profile.svg";
import SearchIcon from "./search.svg";
import ArrowDownIcon from "./arrow-down.svg";
import ArrowLeftIcon from "./arrow-left.svg";
import ArrowRightIcon from "./arrow-right.svg";
import CrossIcon from "./cross.svg";
import FilterIcon from "./filter.svg";
import HeartOutlineIcon from "./heart-outline.svg";
import HeartFilledIcon from "./heart-filled.svg";
import AutumnIcon from "./autumn.svg";
import FlowerIcon from "./flower.svg";
import BikeWhiteIcon from "./bike-white.svg";
import BikeIcon from "./bike.svg";
import CityBuildingIcon from "./city-building.svg";
import CloudIcon from "./cloud.svg";
import GroupIcon from "./group.svg";
import SunIcon from "./sun.svg";
import HandsIcon from "./hands.svg";
import RaftingIcon from "./rafting.svg";
import HikingIcon from "./hiking.svg";
import SnowyIcon from "./seasons.svg";
import LocationIcon from "./location.svg";
import CheckIcon from "./check.svg";
import StopwatchQuarterIcon from "./stopwatch-quarter.svg";
import StopwatchHalfIcon from "./stopwatch-half.svg";
import StopwatchThreeQuartersIcon from "./stopwatch-three-quarters.svg";
import StopwatchFullIcon from "./stopwatch-full.svg";
import InfoIcon from "./info.svg";
import PeopleIcon from "./people.svg";
import MultiPeopleIcon from "./multi-people.svg";
import CalendarBookingIcon from "./calendarBooking.svg";
import EditIcon from "./edit.svg";
import PhoneCallingIcon from "./phone-calling.svg";
import WhatsappIcon from "./whatsapp.svg";
import FacebookIcon from "./facebook.svg";
import InstagramIcon from "./instagram.svg";
import YoutubeIcon from "./youtube.svg";
import LinkedinIcon from "./linkedin.svg";
import TiktokIcon from "./tiktok.svg";
import TwitterXIcon from "./twitter.svg";

// Icon mapping
export const IconsMap = {
  profile: ProfileIcon,
  search: SearchIcon,
  arrowDown: ArrowDownIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  cross: CrossIcon,
  filter: FilterIcon,
  heartOutline: HeartOutlineIcon,
  heartFilled: HeartFilledIcon,
  autumn: AutumnIcon,
  flower: FlowerIcon,
  bikeWhite: BikeWhiteIcon,
  bike: BikeIcon,
  cityBuilding: CityBuildingIcon,
  cloud: CloudIcon,
  group: GroupIcon,
  hands: HandsIcon,
  sun: SunIcon,
  rafting: RaftingIcon,
  snow: SnowyIcon,
  hiking: HikingIcon,
  location: LocationIcon,
  check: CheckIcon,
  stopwatchQuarter: StopwatchQuarterIcon,
  stopwatchHalf: StopwatchHalfIcon,
  stopwatchThreeQuarters: StopwatchThreeQuartersIcon,
  stopwatchFull: StopwatchFullIcon,
  info: InfoIcon,
  people: PeopleIcon,
  calendarBooking: CalendarBookingIcon,
  edit: EditIcon,
  phoneCalling: PhoneCallingIcon,
  whatsapp: WhatsappIcon,
  multiPeople: MultiPeopleIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  youtube: YoutubeIcon,
  linkedin: LinkedinIcon,
  tiktok: TiktokIcon,
  x: TwitterXIcon,
};

type IconProps = {
  name: keyof typeof IconsMap;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
};

const Icon = ({ name, className, width = 24, height = 24, ...props }: IconProps) => {
  const Component = IconsMap[name];
  if (!Component) {
    return null;
  }
    return (
      <Component className={className} width={width} height={height} {...props} />
  );
};

export default Icon;
